import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.item');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { ElementRef, ViewChild } from '@angular/core';
import ClassicEditor from "src/libs/portal/season/ckeditor/ckeditor";
import { Router } from '@angular/router'
import { marked } from 'marked';

@Component({
    selector: 'wiz-portal-gsdcadmin-community-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.item/view.scss */
/* src/app/portal.gsdcadmin.community.item/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityItemComponent implements OnInit, OnDestroy {
    @ViewChild('editor')
    public editorElement: ElementRef;
    public editor: any;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    public community: any = {};
    public groupTotal: any = 0;
    public groups: any = [];
    public users: any = [];

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.communityLoad();
        await this.groupLoad();
        await this.userLoad();
        await this.buildEditor();
    }

    public async communityLoad() {
        const { code, data } = await wiz.call("communityLoad", { id: this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.community = data.community;
        this.groupTotal = data.groupTotal;
        await this.service.render();
    }

    public async groupLoad() {
        const { code, data } = await wiz.call("groupLoad", { id:this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.groups = data;
        await this.service.render();
    }

    public async userLoad() {
        const { code, data } = await wiz.call("userLoad", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.users = data.users;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.userLoad();
    }

    public async buildEditor() {
        if (this.community.description == null) this.community.description = "";
        let editor = this.editor = await ClassicEditor.create(this.editorElement.nativeElement, {
            toolbar: {
                items: [
                    'undo', 'redo',
                    '|', 'heading',
                    '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify',
                    '|', 'bold', 'italic', 'strikethrough', 'underline',
                    '|', 'bulletedList', 'numberedList', 'outdent', 'indent',
                    '|', 'link', 'uploadImage', 'insertTable', 'blockQuote', 'codeBlock', 'horizontalLine'
                ],
                shouldNotGroupWhenFull: true
            },
            codeBlock: {
                languages: [
                    { language: 'plaintext', label: '평문' },
                    { language: 'c', label: 'C' },
                    { language: 'cpp', label: 'C++' },
                    { language: 'cs', label: 'C#' },
                    { language: 'css', label: 'CSS' },
                    { language: 'diff', label: 'Diff' },
                    { language: 'html', label: 'HTML' },
                    { language: 'java', label: 'Java' },
                    { language: 'javascript', label: 'JavaScript' },
                    { language: 'markdown', label: 'Markdown' }, // 여기서 Markdown 추가
                    { language: 'php', label: 'PHP' },
                    { language: 'python', label: 'Python' },
                    { language: 'ruby', label: 'Ruby' },
                    { language: 'typescript', label: 'TypeScript' },
                    { language: 'xml', label: 'XML' }
                ]
            },
            link: {
                addTargetToExternalLinks: true,
                defaultProtocol: 'https://',
            },
            removePlugins: ["MediaEmbedToolbar"],
            table: ClassicEditor.defaultConfig.table,
            simpleUpload: {
                uploadUrl: '/file/upload'
            }
        });
        this.editor.data.set(this.community.description);
    }

    public async ngOnDestroy() {
        this.community.description = this.editor.getData();
    }

    public async update() {
        if (this.tab == 'text') this.changeTab('editor')
        this.community.description = this.editor.getData();
        if (this.community.name == "") return await this.service.alert.error("연구커뮤니티 명을 입력해주세요.");
        else if (!('regist_pi' in this.community)) return await this.service.alert.error("PI 승인 절차를 선택해주세요.");
        else if (!('regist_user' in this.community)) return await this.service.alert.error("개인 연구자 승인 절차를 선택해주세요.");
        const { code } = await wiz.call("update", this.community);
        if (code != 200) await this.service.alert.error("오류가 발생했습니다.");
        let res = await this.service.alert.success("저장되었습니다.");
        if (res && !('id' in this.community)) await this.router.navigate(['/admin/community']);
        await this.service.render();
    }

    public tab: 'editor' | 'text' = 'editor';

    public async changeTab(tab: 'editor' | 'text') {
        if (!this.editor) {
            this.tab = tab;
            await this.service.render();
            return;
        }

        if (this.tab === 'editor' && tab === 'text') this.community.description = this.editor.getData();
        if (this.tab === 'text' && tab === 'editor') this.editor.setData(this.community.description || '');

        this.tab = tab;
        await this.service.render();
    }

    public async changeLeader(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;

        const original = user.representative;               // 'Y' or 'N'
        const next = checkbox.checked ? 'Y' : 'N';          // 클릭 후 상태

        user.representative = next;
        await this.service.render();

        let res: any;
        if (next === 'Y') {
            res = await this.service.alert.show({ title: "연구커뮤니티 대표 지정", message: "해당 사용자를 연구커뮤니티 대표로 지정하시겠습니까?", action: "지정", cancel: "취소", actionBtn: 'success', status: 'success' });
        } else {
            res = await this.service.alert.show({ title: "연구커뮤니티 대표 해제", message: "해당 사용자를 연구커뮤니티 대표 해제하시겠습니까?", action: "해제", cancel: "취소", actionBtn: 'error', status: 'error' });
        }

        if (res !== true) {
            user.representative = original;
            await this.service.render();   // ← 이게 없으면 체크박스 UI 안 바뀜
            return;
        }

        const { code } = await wiz.call("changeLeader", {user: JSON.stringify(user), community: JSON.stringify(this.community)});

        if (code !== 200) {
            // 실패 시에도 롤백
            user.representative = original;
            await this.service.render();
            return;
        }

        await this.service.alert.success("연구커뮤니티 대표 지정/해제 완료했습니다.");
    }
}

export default PortalGsdcadminCommunityItemComponent;